export const ALL_SPECIALITY = 'ALL_SPECIALITY';
export const SPECIALITY_FEED_DATA = 'SPECIALITY_FEED_DATA';
export const GET_USER_ACTIVITIES = 'GET_USER_ACTIVITIES';
export const GET_ACTIVITY_DATES = 'GET_ACTIVITY_DATES';